import React from 'react';
import {
  Collapse as MUICollapse,
  CollapseProps as MUICollapseProps,
} from '@mui/material';

export const Collapse = (props: MUICollapseProps) => <MUICollapse {...props} />;
